<template>
  <div class="account-damage-display">
    <span v-if="!damage.resolved" class="label label-danger pull-right label-margin">
      Unresolved
    </span>
    <span v-if="damage.resolved" class="label label-success pull-right label-margin">
      Resolved
    </span>
    <span v-if="!damage.repaired" class="label label-danger pull-right label-margin">
      Unrepaired
    </span>
    <span v-if="damage.repaired" class="label label-success pull-right label-margin">
      Repaired
    </span>
    <h3>Damage Details</h3>
    <p v-if="damage.resolved">
      <strong>Resolved by:</strong>
      <template v-if="damage.AdminResolved">
        <router-link :to="{ path: '/membership/members/' + damage.AdminResolved.uuid }">
          {{ damage.AdminResolved.dropdownLabel }}
        </router-link>
      </template>
      <template v-else>
        Auto-resolved
      </template>
    </p>
    <p v-if="damage.Car">
      <strong>Car: </strong>
      <router-link :to="{ path: '/fleet/vehicles/' + damage.Car.uuid }">
        {{ damage.Car.dropdownLabel }}
      </router-link>
    </p>
    <p v-if="damage.Reservation">
      <strong>Reservation: </strong>
      <router-link :to="{ path: '/fleet/reservations/' + damage.Reservation.uuid }">
        #{{ damage.Reservation.reservationId }}
      </router-link>
    </p>
    <p v-if="damage.Account">
      <strong>Reported By: </strong>
      <router-link :to="{ path: '/membership/members/' + damage.Account.uuid }">
        {{ damage.Account.dropdownLabel }}
      </router-link>
    </p>
    <p v-if="damage.AdminResponsible">
      <strong>Admin Responsible: </strong>
      <router-link :to="{ path: '/membership/members/' + damage.AdminResponsible.uuid }">
        {{ damage.AdminResponsible.dropdownLabel }}
      </router-link>
    </p>
    <p>
      <strong>Date: </strong> {{ damage.dateLogged | date_format }}
    </p>
    <p>
      <h5>Description</h5>
      <div v-if="damage.description" v-html="nl2br(damage.description)"></div>
      <em v-else>None provided.</em>
    </p>
    <template v-if="damage.repaired">
      <h5>Repair Details</h5>
      <strong>Marked as Repaired by:</strong>
      <template v-if="damage.AdminRepaired">
        <router-link :to="{ path: '/membership/members/' + damage.AdminRepaired.uuid }">
          {{ damage.AdminRepaired.dropdownLabel }}
        </router-link>
      </template>
      <p>
        <strong>Date Repaired: </strong> {{ damage.dateRepaired | short_date_format }}<br/>
        <strong>Repair Cost: </strong> {{ damage.repairCost | to_dollar_amount }}<br/>
        <strong>Insurance Claim Made: </strong> {{ damage.insuranceClaim ? 'Yes' : 'No' }}<br/>
        <strong>Description:</strong>
        <span v-html="nl2br(damage.repairDescription)"></span>
      </p>
    </template>
    <div v-if="damage.AmazonImages && damage.AmazonImages.length">
      <h5>Image(s)</h5>
      <template v-for="(image, index) in damage.AmazonImages">
        <a v-if="image.objectKey.includes('pdf')" target="_blank"
        :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
          PDF {{ index + 1 }}
        </a>
        <a v-else target="_blank"
        :href="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`">
          <img :src="`https://techcar-dev.s3.amazonaws.com/${image.objectKey}`" class="img-fluid" />
        </a>
      </template>
    </div>
    <button class="btn btn-success btn-sm" type="button"
    @click="resolveCarDamage" v-if="!damage.resolved">
      <span class="fa fa-check"></span> Mark As Resolved
    </button>
    <button class="btn btn-warning btn-sm" type="button"
    @click="repairDamageModal" v-if="!damage.repaired">
      <span class="fa fa-wrench"></span> Mark As Repaired
    </button>
  </div>
</template>

<script>
import { RESOLVE_DAMAGE, REPAIR_DAMAGE } from '@/vuex/types'
export default {
  name: 'CarDamageDisplay',
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    damage () {
      return {
        ...this.data,
        ...this.updatedDamage
      }
    }
  },
  data () {
    return {
      updatedDamage: {}
    }
  },
  methods: {
    nl2br (message) {
      return this.$root.$options.filters['nl2br'](message)
    },
    async resolveCarDamage () {
      let result = await this.$store.dispatch(RESOLVE_DAMAGE, this.damage.uuid)
      this.updatedDamage = result
    },
    repairDamageModal () {
      this.$store.dispatch(REPAIR_DAMAGE, this.damage.uuid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/CarDamageDisplay.vue